import Vue from "vue";
import lang from "@/lang/index.js";
import saveAssistent from "./saveAssistent.js";

export default function() {
  this.store = "";
  this.data = "";
  this.services = "";
  this.callback = function() {};
  this.error = "";
  this.user = "";

  this.save = function() {
    this.data = this.store.rootState.business.assistent;
    this.privateData = this.store.rootState.privateEvent.assistent;
    this.service = this.store.rootState.service.services;
    this.user = this.store.rootState.save.userData;
    this.callbacks[0]();
  };

  this.callbacks = [
    function() {
      this.registerUser();
    }.bind(this),
    function(ret) {
      this.checkRegisterUser(ret);
    }.bind(this),
    function() {
      this.sendValidationMail();
    }.bind(this),
    function() {
      var s = new saveAssistent();
      s.checkService = false;
      s.store = this.store;
      s.callback = this.callback;
      s.save();
    }.bind(this)
  ];

  this.postData = function(url, data, callback) {
    Vue.prototype.$flix_post({
      url: url,
      data: data,
      callback: function(ret) {
        callback(ret.data);
      },
      api_url: this.store.rootState.save.apiUrl
    });
  };

  this.registerUser = function() {
    this.postData(
      "user/register",
      {
        username: this.user.username,
        password: this.user.pass,
        email: this.user.email,
        noEmail: true
      },
      this.callbacks[1]
    );
  };

  this.checkRegisterUser = function(ret) {
    if (!ret[0]) {
      this.error = lang.t("register.doublicatedAccount");
      this.callback(false, this.error);
      return false;
    }
    this.user = ret[1];
    this.store.commit("setRegistredUser", ret[1]);
    this.callbacks[2]();
  };

  this.sendValidationMail = function() {
    var user = this.store.rootState.save.registredUser;
    var mail = lang.t("register.validateUseraccount");
    var link =
      Vue.prototype.$flix_url + "/validate/" + btoa(user.md5_id) + ".html";

    this.postData(
      "user/registermail",
      {
        user: user.md5_id,
        to: user.email,
        title: mail.emailTitle,
        text: mail.emailText
          .split("{link}")
          .join('<a href="' + link + '">' + link + "</a>")
          .split("{url}")
          .join(Vue.prototype.$flix_url)
      },
      this.callbacks[3]
    );
  };
}
